import { FormGroup } from "@angular/forms";
import { AsEnumerable, asEnumerable } from "linq-es2015";
import { ConjunctionEnum } from "../../../../shared/models/conjunction.enum";
import { PollinationStakeLabelService } from "../../../../shared/services/pollination-stake-label.service";
import { ResolvedRequestOptionsService } from "../../../services/resolved-request-options";
var PollinationStakeLabelComponent = /** @class */ (function () {
    function PollinationStakeLabelComponent(stakeLabelService, routeData) {
        this.stakeLabelService = stakeLabelService;
        this.routeData = routeData;
        this.stakeLabel = "";
    }
    Object.defineProperty(PollinationStakeLabelComponent.prototype, "pollinationPreferences", {
        get: function () {
            return this.pollinationInstructions.get("pollinationPreferences");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PollinationStakeLabelComponent.prototype, "pollinationCategory", {
        get: function () {
            return this.pollinationInstructions.get("pollinationCategory");
        },
        enumerable: true,
        configurable: true
    });
    PollinationStakeLabelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateStakeLabel();
        this.pollinationInstructions
            .valueChanges
            .subscribe(function () {
            _this.updateStakeLabel();
        });
    };
    PollinationStakeLabelComponent.prototype.updateStakeLabel = function () {
        var instructions = this.pollinationInstructions.value;
        var items = this.getStakeLabelItemData(instructions);
        var pollinationCategoryId = instructions.pollinationCategory;
        if (!pollinationCategoryId) {
            this.stakeLabel = this.stakeLabelService.createStakeLabel(items, null, null);
            return;
        }
        var category = this.routeData.requestOptions.pollinationCategories.find(function (c) { return c.id === pollinationCategoryId; });
        var pollinationCategoryName = category ? category.name : null;
        this.stakeLabel = this.stakeLabelService.createStakeLabel(items, pollinationCategoryId, pollinationCategoryName);
    };
    PollinationStakeLabelComponent.prototype.getStakeLabelItemData = function (instructions) {
        var _this = this;
        var preferenceGroups = instructions.pollinationPreferences;
        var hasCategory = instructions.pollinationCategory != null;
        return AsEnumerable(preferenceGroups)
            .SelectMany(function (g, groupIndex) {
            return asEnumerable(g.items)
                .Select(function (i, itemIndex) { return ({
                groupIndex: groupIndex,
                groupConjunction: _this.stakeLabelService.getGroupConjunction(groupIndex, g.conjunction, hasCategory),
                itemIndex: itemIndex,
                itemConjunction: itemIndex === 0 ? "" : (i.conjunction === ConjunctionEnum.And ? "&" : "/"),
                pollinationType: i.pollinationType,
                geName: i.geName,
                truncatedPollinationType: ""
            }); });
        })
            .ToArray();
    };
    return PollinationStakeLabelComponent;
}());
export { PollinationStakeLabelComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-stake-label/pollination-stake-label.component.ts.pre-build-optimizer.js